import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import { PICKER_COMPONENT_HEIGHT } from "./ScrollDatePickerOption";

const DateEditModalBox = styled.div`
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;

    width: 240px;
    height: fit-content;
    background-color: var(--bg-color);
    border: 1px solid var(--text-color);


    &.display {
        display: flex;
    }

    &.hidden {
        display: none;
    }

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 4px;
    align-items: center;

    padding: 4px 12px;
    border-radius: 8px;

    & > button {
        /* width: 60px; */
        flex: 1;
        height: 100%;
        background-color: transparent;
        /* border: 1px solid var(--text-color); */
        border: none;
        outline: none;
        /* border-bottom: 1px solid var(--text-color); */
        color: var(--text-color);
        font-size: .925rem;
        /* border-radius: 4px; */
    }
`;

const ScrollDatePickerBox = styled.div`
    width: 37%;
    height: ${PICKER_COMPONENT_HEIGHT * 2.3}px;

    overflow-y: auto;
    scroll-snap-type: y mandatory; /* y 축 방향으로만 scroll snap 적용 */

    padding: 0 8px;

    /* Hidden Scrollbar */
    -ms-overflow-style: none;
    &::-webkit-scrollbar{
        display:none;
    }

    & > div {
        height: ${100 / 2.3}%;
        display: flex;
        justify-content: center;
        align-items: center;
        scroll-snap-align: center;
        scroll-padding: ${PICKER_COMPONENT_HEIGHT / 2}px 0;
        /* scroll-snap-stop: always; */
        opacity: 0.4;

        border-radius: 4px;
        font-size: .825rem;

        &:first-child {
            margin-top: ${PICKER_COMPONENT_HEIGHT}px;
        }

        &:last-child {
            margin-bottom: ${PICKER_COMPONENT_HEIGHT}px;
        }

        &.focus {
            opacity: 1;
            font-size: .95rem;
        }
        &.selected {
            background-color: var(--gray-color);
        }
    }
`;

interface DateEditModal {
    currentMonth: Date,
    handleClick: (selectedYear: number, selectedMonth: number) => void;
};

const DateEditModal = ({currentMonth, handleClick} : DateEditModal) => {
    const yearScrollRef = useRef<(HTMLDivElement | null)[]>([]);
    const monthScrollRef = useRef<(HTMLDivElement | null)[]>([]);
    // eslint-disable-next-line
    const [yearScrollElements, setYearScrollElements] = useState([2021, 2022, 2023, 2024, 2025]);
    // eslint-disable-next-line
    const [monthScrollElements, setMonthScrollElements] = useState(Array.from({length: 12}, (_, i) => i + 1));
    const [selectedYear, setSelectedYear] = useState(yearScrollElements[-1]);
    const [selectedMonth, setSelectedMonth] = useState(monthScrollElements[-1]);
    // const [focusYear, setFocusYear] = useState(selectedYear);
    // const [focusMonth, setFocusMonth] = useState(selectedMonth);
    const onScrollDatePicker = (e: any, type: string) => {
        const currentOffset = Math.ceil(e.target.scrollTop / PICKER_COMPONENT_HEIGHT) - 1;
        let value = 0;
        if(type === "year") {
            value = yearScrollElements[currentOffset];
            setSelectedYear(value);
        }
        else if (type === "month") {
            value = monthScrollElements[currentOffset];
            setSelectedMonth(value);
        }
    }

    useEffect(() => {
        const yearOffset = yearScrollElements.findIndex((year) => currentMonth.getFullYear() === year);
        const monthOffset = monthScrollElements.findIndex((month) => currentMonth.getMonth() === (month - 1));

        yearScrollRef?.current[yearOffset].scrollIntoView({ behavior: "smooth", block: 'center' });
        monthScrollRef?.current[monthOffset].scrollIntoView({ behavior: "smooth", block: 'center' });
    }, [currentMonth, yearScrollElements, monthScrollElements]);

        
    // 나중에는 데이터가 하루도 없는 달이면 없다는 UI를 표현해서 선택이 안되도록 해도 좋겠다
    return (
        <DateEditModalBox>
            <ScrollDatePickerBox onScrollEnd={(e) => onScrollDatePicker(e, "year")}>
                { // 추후에 최소 년 ~ 최대 년 으로 계산
                yearScrollElements.map((year, i) => 
                    <div
                    ref={(el) => {yearScrollRef.current[i] = el}}
                    key={`year-${year}`} 
                    className={`year-picker picker ${currentMonth && currentMonth.getFullYear() === year && "selected"} ${selectedYear === year && "focus"}`}>
                        {year !== 0 && year}
                    </div>)
                }
            </ScrollDatePickerBox>
            <ScrollDatePickerBox onScrollEnd={(e) => onScrollDatePicker(e, "month")}>
                {
                monthScrollElements.map((month, i) => 
                    <div 
                    ref={(el) => {monthScrollRef.current[i] = el}}
                    key={`month-${month}`}  
                    className={`month-picker picker ${currentMonth && currentMonth.getMonth() + 1 === month && "selected"} ${selectedMonth === month && "focus"}`}>
                        {month !== 0 && month}
                    </div>
                    )
                }
            </ScrollDatePickerBox>
            <button onClick={() => handleClick(selectedYear, selectedMonth - 1)}>선택</button>
        </DateEditModalBox>
    );
}

export default DateEditModal;